// src/chains/infinaeon.js - Keep using direct contract calls for now
import { createChainConfig } from './chainConfig';

export const infinaeonConfig = createChainConfig({
  key: 'infinaeon', 
  chainId: 420000,
  name: 'Infinaeon',
  rpcUrl: 'https://rpc.infinaeon.com',
  explorerUrl: 'https://explorer.infinaeon.com',
  
  // Native token information
  nativeTokenSymbol: 'ETH',
  nativeTokenName: 'Ethereum',
  nativeTokenIcon: 'https://i.imgur.com/0ZOPyLn.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0xcA7de02C635ff4f029641ed6AB46c5EBe09a5C8a', // WETH on INFINAEON
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'ethereum',
  geckoTerminalId: 'infinaeon',
  tokenListUrl: 'https://bit-dog.com/infinaeon.json',
  
  // BitDogSwap aggregator address - continue using direct contract calls
  aggregatorAddress: '0x7d05aDf2BDccf7fF710EA66aEa2f0b78eF299688',
  
  // Transaction support
  supportsEIP1559: false,

});